import { Reports } from "../reports"

export const OnboardingReports = ({ pageSwap }) => {
    return (
        <Reports
            CustomerStage={2}
            pageSwap={pageSwap}
        />)
}